import * as itinerary from "@COMPONENTS/style/detailpackage/itinerarytemplate";

import useOverlay from "@/hooks/common/useOverlay";
import TravelInfoPopup from "@COMPONENTS/product/common/popup/desktop/TravelInfoPopup";
import * as optiondetail from "@COMPONENTS/style/detailpackage/optiondetail";
import {EventTourDetail} from "@QUERIES/prdt/event/useEventTourDetail";
import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import useEventTourDetail from "@QUERIES/bff/useEventTourDetail";
import {Noimage} from "@yb/ui/desktop/common/Noimage";

const TourDetailTemplateComponent = (detail: EventTourDetail) => {
	const {trvInfoNm, trvCd, locNm, tempCd, trvInfoYn, trvContent, refeNote, optCost, useTm, trvInfoId} = detail;

	const [open] = useOverlay();
	const openMore = e => {
		e.preventDefault();
		open(props => <TravelInfoPopup {...props} trv={detail} />);
	};

	return (
		<itinerary.TemplateItem>
			<itinerary.Title>
				<h5>{trvInfoNm && `${trvCd === "70" ? "[선택관광] " : ""} ${trvInfoNm} ${locNm ? `(${locNm})` : ""}`}</h5>
				{trvInfoId && trvCd !== "10" && trvInfoNm && (
					<a href="#" onClick={openMore}>
						더보기
					</a>
				)}
			</itinerary.Title>
			<itinerary.ThumbnailList grid={Number(tempCd) === 4 ? 1 : Number(tempCd)}>
				{Array.from({length: Number(tempCd) === 4 ? 1 : Number(tempCd)}, (_, i) => {
					const url = `image${i + 1}Url`;
					const urlNm = `imageNm${i + 1}`;
					return (
						<itinerary.ThumbnailItem key={`thumb${i}`}>
							<Noimage width="100%" height="auto" src={detail[url] || ""} alt="상품 이미지" />
							{detail[urlNm] && <em>{detail[urlNm]}</em>}
						</itinerary.ThumbnailItem>
					);
				})}
			</itinerary.ThumbnailList>
			{trvInfoYn === "Y" && trvContent && <itinerary.Text dangerouslySetInnerHTML={{__html: trvContent}} />}
			{refeNote && (
				<itinerary.Notice>
					<h4>참고하세요</h4>
					<itinerary.NoticeText dangerouslySetInnerHTML={{__html: refeNote}} />
				</itinerary.Notice>
			)}
			{(optCost || useTm) && (
				<itinerary.InfoBox>
					<itinerary.InfoList>
						{optCost && (
							<li>
								<itinerary.InfoTitle>비용</itinerary.InfoTitle>
								<itinerary.InfoContent>{optCost}</itinerary.InfoContent>
							</li>
						)}
						{useTm && (
							<li>
								<itinerary.InfoTitle>소요시간</itinerary.InfoTitle>
								<itinerary.InfoContent>{useTm}</itinerary.InfoContent>
							</li>
						)}
					</itinerary.InfoList>
				</itinerary.InfoBox>
			)}
		</itinerary.TemplateItem>
	);
};

/**
 * 탬플릿
 * 숙소 | 관광지 | 즐길거리 | 먹거리 | 일차별 일정
 */
const TourDetailTemplate = (props: EventTourDetail) => (
	<ErrorBoundary logMsg="TemplateTabs TourDetailTemplate Error">
		<TourDetailTemplateComponent {...props} />
	</ErrorBoundary>
);

const AccommodationComponent = ({evCd}: {evCd: string}) => {
	const useEventTourDtl = useEventTourDetail(evCd);
	const accomm = useEventTourDtl.data.accommodation;
	return (
		<>
			<optiondetail.TabContent>
				<optiondetail.ContentTitle>{accomm.title}</optiondetail.ContentTitle>
				<itinerary.TemplateList>
					{accomm.data.map((item, index) => (
						<TourDetailTemplate {...item} key={index} />
					))}
				</itinerary.TemplateList>
			</optiondetail.TabContent>
		</>
	);
};

/**
 * 숙소
 */
const Accommodation = (props: {evCd: string}) => (
	<ErrorBoundary logMsg="TemplateTabs Accommodation Error">
		<AccommodationComponent {...props} />
	</ErrorBoundary>
);

const TourlistDesinationComponent = ({evCd}: {evCd: string}) => {
	const useEventTourDtl = useEventTourDetail(evCd);
	const tourlistdest = useEventTourDtl.data.tourSpot;
	return (
		<>
			<optiondetail.TabContent>
				<optiondetail.ContentTitle>{tourlistdest.title}</optiondetail.ContentTitle>
				<itinerary.TemplateList>
					{tourlistdest.data.map((item, index) => (
						<TourDetailTemplate {...item} key={index} />
					))}
				</itinerary.TemplateList>
			</optiondetail.TabContent>
		</>
	);
};

/**
 * 관광지
 */
const TourlistDestination = (props: {evCd: string}) => (
	<ErrorBoundary logMsg="TemplateTabs TourlistDestination Error">
		<TourlistDesinationComponent {...props} />
	</ErrorBoundary>
);

const EnjoyComponent = ({evCd}: {evCd: string}) => {
	const useEventTourDtl = useEventTourDetail(evCd);
	const enjoy = useEventTourDtl.data.entertainment;
	return (
		<>
			<optiondetail.TabContent>
				<optiondetail.ContentTitle>{enjoy.title}</optiondetail.ContentTitle>
				<itinerary.TemplateList>
					{enjoy.data.map((item, index) => (
						<TourDetailTemplate {...item} key={index} />
					))}
				</itinerary.TemplateList>
			</optiondetail.TabContent>
		</>
	);
};

/**
 * 즐길거리
 */
const Enjoy = (props: {evCd: string}) => (
	<ErrorBoundary logMsg="TemplateTabs Enjoy Error">
		<EnjoyComponent {...props} />
	</ErrorBoundary>
);

const FoodComponent = ({evCd}: {evCd: string}) => {
	const useEventTourDtl = useEventTourDetail(evCd);
	const food = useEventTourDtl.data.food;
	return (
		<>
			<optiondetail.TabContent>
				<optiondetail.ContentTitle>{food.title}</optiondetail.ContentTitle>
				<itinerary.TemplateList>
					{food.data.map((item, index) => (
						<TourDetailTemplate {...item} key={index} />
					))}
				</itinerary.TemplateList>
			</optiondetail.TabContent>
		</>
	);
};

/**
 * 먹거리
 */
const Food = (props: {evCd: string}) => (
	<ErrorBoundary logMsg="TemplateTabs Food Error">
		<FoodComponent {...props} />
	</ErrorBoundary>
);

export {Accommodation, Enjoy, Food, TourDetailTemplate, TourlistDestination};
